import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PipesModule } from "src/app/pipes/pipes.module";
import { AltpaymentModalModule } from "../altpayment-modal/altpayment-modal.module";
import { DisplayCurrencyModule } from "../display-currency/display-currency.module";
import { AlternatePaymentComponent } from "./alternate-payment.component";
import { ConsentModalModule } from "../consent-modal/consent-modal.module";
import { AlternatePaymentModalModule } from "../alternate-payment-modal/alternate-payment-modal.module";

@NgModule({
  declarations: [AlternatePaymentComponent],
  imports: [
    CommonModule,
    PipesModule,
    AltpaymentModalModule,
    DisplayCurrencyModule,
    ConsentModalModule,
    AlternatePaymentModalModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [AlternatePaymentComponent],
})
export class AlternatePaymentModule {}
